import { computed } from 'vue';
import { useUISettings } from './useUISettings';

export function useMessageTranslation() {
  const { uiSettings, updateUISettings } = useUISettings();

  const currentTranslationMode = computed(() => {
    return uiSettings.value.message_translation_mode || 'original';
  });

  const updateTranslationMode = mode => {
    updateUISettings({ message_translation_mode: mode });
  };

  return {
    currentTranslationMode,
    updateTranslationMode,
  };
}
